module.exports = __webpack_public_path__ + "img/04.a1337012.png";